export enum GlobalSettingsActionTypes {
  GET_GLOBAL_SETTINGS = '@player/GET_GLOBAL_SETTINGS',
}
